<template>
  <v-card>
    <v-card-text>
      <div class="pa-4">
        <div class="d-flex align-center mt-4">
          <v-divider></v-divider>
          <span class="mx-8"><h3>Issuing Information</h3></span>
          <v-divider></v-divider>
        </div>

        <div class="my-8">
          <slot name="top"></slot>
        </div>

        <div class="d-flex align-center">
          <v-divider></v-divider>
          <span class="mx-8"><h3>NFT Metadata</h3></span>
          <v-divider></v-divider>
        </div>

        <div class="my-8">
          <v-row>
            <v-col class="col-12 col-sm-6">
              <div class="d-flex justify-center">
                <div class="d-flex flex-column align-center mb-4">
                  <v-btn
                      color="indigo"
                      dark
                      class="font-600 text-capitalize"
                      :loading="isSelecting"
                      @click="handleFileImport"
                  >
                    Select Files *
                  </v-btn>
                  <div class="text-14 grey--text text--darken-2 mt-2">Upload 280*280 image</div>
                </div>
                <input
                    ref="uploader"
                    class="d-none"
                    type="file"
                    name="abc"
                    @change="onFileChanged"
                >
              </div>
              <v-responsive :aspect-ratio="1" class="align-center justify-center grey">
                <v-img
                    dark
                    :src="previewImage"
                    contain
                    aspect-ratio="1"
                    class="grey lighten-3"
                ></v-img>
              </v-responsive>

              <!--          <v-col cols="12" sm="6" lg="4" class="mx-auto">-->
              <!--            -->
              <!--          </v-col>-->
            </v-col>
            <v-col class="col-12 col-sm-6">
              <p class="text-14 mb-1">Name *</p>
              <v-text-field
                  outlined
                  dense
                  v-model="metadata.name"
                  :rules="[rules.required]"
              ></v-text-field>

              <p class="text-14 mb-1 mt-2">Description *</p>
              <v-textarea
                  outlined
                  dense
                  v-model="metadata.description"
                  :rules="[rules.required]"
              ></v-textarea>

              <p class="text-14 mb-1 mt-2">External Url</p>
              <v-text-field
                  outlined
                  dense
                  hide-details
                  v-model="metadata.externalUrl"
              ></v-text-field>

              <v-divider class="my-4"></v-divider>

              <div class="text-end">
                <v-btn outlined color="indigo" small @click="addTraitHandle">
                  Add Trait
                </v-btn>
              </div>

              <div
                  class="d-flex align-center justify-center"
                  v-for="(trait, index) in metadata.attributes" :key="index"
              >
                <div class="d-flex flex-column align-center mr-4" @click="deleteTraitHandle(index)">
                  <span class="font-weight-medium">Trait {{ index + 1 }}</span>
                  <v-icon style="position: relative; top: 12px" class="cursor-pointer">mdi-trash-can-outline</v-icon>
                </div>
                <div class="flex-grow-1">
                  <p class="text-14 mb-1">Name</p>
                  <v-text-field
                      outlined
                      dense
                      hide-details
                      v-model="trait.trait_type"
                  ></v-text-field>

                  <p class="text-14 my-1">Value</p>
                  <v-text-field
                      outlined
                      dense
                      hide-details
                      v-model="trait.value"
                  ></v-text-field>
                  <v-divider class="my-4"></v-divider>
                </div>
              </div>
            </v-col>
          </v-row>
        </div>

        <slot name="createBtn" v-bind="{metadata, uploadNftMetadata}"></slot>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import helper from "@/lib/helper/index";
import backendCall from "@/lib/backendCall/index";

export default {
  name: "NftForm",
  data() {
    return {
      isSelecting: false,
      isUploading: false,
      selectedFile: null,
      previewImage: "", //base64 image src
      metadata: {
        name: "",
        description: "",
        externalUrl: "",
        attributes: []
      },
      rules: {
        required: value => !!value || 'Required.'
      }
    }
  },
  methods: {
    handleFileImport() {
      this.isSelecting = true;

      // After obtaining the focus when closing the FilePicker, return the button state to normal
      window.addEventListener('focus', () => {
        this.isSelecting = false
      }, {once: true});

      // Trigger click on the FileInput
      this.$refs.uploader.click();
    },
    async onFileChanged(e) {
      this.selectedFile = e.target.files[0];
      this.previewImage = await helper.image.imgFileToBase64(this.selectedFile);
    },
    async addTraitHandle() {
      this.metadata.attributes.push({
        trait_type: "",
        value: ""
      })
    },
    async deleteTraitHandle(traitIndex) {
      this.metadata.attributes.splice(traitIndex, 1)
    },
    async uploadNftMetadata() {
      let formData = new FormData();
      if (!this.selectedFile) {
        throw Error('Image file cannot be empty')
      }
      formData.append('file', this.selectedFile)
      formData.append('metadata', JSON.stringify(this.metadata))

      this.isUploading = true

      try {
        const res = await backendCall.nft.uploadNftMetadata(formData)
        //feedback handling
        this.isUploading = false
        if (res.status === 1) {
          console.log("Success to upload metadata")
          return res.data.ipfsUrl
        } else if (res.status === 0) {
          throw Error(res.message)
        }
      } catch (e) {
        console.error("Fail to upload metadata, Error message: ", e.message)
      }
    }
  }
}
</script>

<style scoped>

</style>